module.exports = __webpack_public_path__ + "img/22.04db87da.png";